<template>
  <div class="issuetypes">
    <b-container fluid="xxl">
      <b-row>
        <b-col id="select-issuetype">
          <b-form-group
            id="issuetype"
            label="Issue Type:"
            label-for="issuetype"
          >
            <Select2 @select="select($event)" :settings="selectConfig" ref="select2" tabindex="0" />
          </b-form-group>

          <b-form-group
            id="ordering"
            label="Ordering:"
            label-for="ordering"
            v-if="showOrdering"
          >
            <b-form-input
              id="ordering"
              v-model="ordering"
              placeholder="Ordering"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>

    <b-modal id="modal-new-issue-type" title="New Issue Type" ok-title="Save" @ok="saveNew" >
      <IssueTypeNewEdit :issuetype="{'form': this.query}" />
    </b-modal>
  </div>
</template>

<script>
import HelpStore from "@/store/helpstore.js";
import Select2 from 'v-select2-component';
import IssueTypeNewEdit from "@/components/Scripta/IssueTypeNewEdit.vue";
import config from '@/config.js';

export default {
  name: "IssueTypeAutocomplete",
  props: ["exclude", "issueType", "showOrdering", "headId", "orderingNum", "parentId"],
  data() {
    return {
      query: "",
      timer: null,
      issueTypeObj: this.issueType,
      parentIdElem: this.parentId ? this.parentId : "select-issuetype",
      ordering: this.issueType ? this.issueType.ordering : (this.orderingNum ? this.orderingNum : 1),
      index: this.issueType ? this.issueType._index : null,
      showAddNew: this.allowNew == false ? false : true,
    };
  },
  components: {
    Select2,
    IssueTypeNewEdit,
  },
  methods: {
    select(event){
      if (event.selected && event.id == -2){
        this.$bvModal.show("modal-new-issue-type")
      }
      else {
        this.issueTypeObj = event.selected ? event.issueType : null
        this.$emit("select", this.issueTypeObj)
        this.update()
      }
    },
    saveNew(){
      this.$store.dispatch('createIssuetype', HelpStore.item).then((response) => {
        this.issueTypeObj = response.data
        this.$refs.select2.select2.append(
          `<option selected value="${this.issueTypeObj.id}">${this.issueTypeObj.form}</option>`
        ).trigger('change')
        HelpStore.item = this.issueTypeObj
      })
    },
    update(){
      if (this.issueTypeObj){
        this.issueTypeObj["ordering"] = this.ordering;
        this.issueTypeObj["_index"] = this.index;
        HelpStore.item = this.issueTypeObj;
      }
    },
  },
  updated() {
    this.update()
  },
  mounted() {
    if (this.issueType){
      this.$refs.select2.select2.append(
        `<option selected value="${this.issueType.id}">${this.issueType.form}</option>`
      ).trigger('change')
    }
  },
  computed: {
    selectConfig(){
      return {
        placeholder: "Select an issue type",
        // allowClear: this.allowClear == false ? false : true,
        width: '100%',
        dropdownParent: `#${this.parentIdElem}`,
        templateSelection: (val) => {
          return val.form ? val.form : val.text
        },
        ajax: {
          delay: 250,
          url: config.apiUrl + '/issuetypes/autocomplete',
          headers: config.apiHeaders,
          data: (params) => {
            this.query = params.term
            return {
              query: params.term,
              // headId: this.headId,
              exclude: JSON.stringify(this.exclude),
            }
          },
          processResults: (data) => {
            if (data.length == 0 && this.showAddNew && this.query){
              data.push({
                id: -2,
                form: `Create new "${this.query}"`
              })
            }
            return {
              results: data.map(issueType => {
                let text = issueType.form
                let orderNum = 0
                if (issueType.id != -2 && !issueType.heads.map(head => head.id).includes(this.headId)) {
                  text = `${text} (not connected to head)`
                  orderNum = 1
                }
                return {
                  id: issueType.id,
                  text: text,
                  orderNum: orderNum,
                  form: issueType.form,
                  issueType: issueType
                }
              }).sort((a, b) => a.orderNum - b.orderNum)
            }
          }
        }
      }
    }
  },
};
</script>
